import { useGetUserGroups } from "api/generated/user-groups/user-groups";

export const useSearchUserGroupQuery = (search: string) =>
    useGetUserGroups(
        { format: "WithUsers", name: search },
        {
            query: {
                select: (response) => {
                    if (response.data.type !== "WithUsers") {
                        throw new Error("Expected WithUsers response type");
                    }
                    return response.data.data.content.map(
                        (dto) => dto.resource
                    );
                },
                enabled: search.length > 0,
                staleTime: 30 * 1000,
            },
        }
    );
